<template>
  <div class="attr-topic-item">
    <CompTodoList v-model="value" @onAddItem="handleClickAdd">
      <template slot="body" slot-scope="scope">
        <div class="topic-item">
          <el-input
            v-model="scope.data.title"
            placeholder="标题"
            size="small"
            class="topic-input"
          />
          <el-row v-if="scope.data.children" :gutter="10">
            <draggable :list="scope.data.children" :options="dragOptions" style="width: 100%" handle=".mover">
              <el-col class="mover" :span="12" v-for="(child, index) of scope.data.children" :key="index">
                <div class="tag-item" :class="childNum === index + '' + scope.data.title ?  'active' : ''" @click="handleClick(scope.data, child, index)">
                  <div :class="['wgt-icon', 'wgt-search']" />
                  <div class="wgt-name">
                    {{ child.wgtName}}
                  </div>
                  <i class="el-icon-error tag-icon" @click.stop="handleClose(scope.data, child.wgtName, index)"></i>
                </div>
<!--                <div style="padding-top: 10px; cursor: pointer">-->
<!--                  <el-tag style="width: 150px;height: 100px;"  effect="plain" :type="childNum === index + '' + scope.data.title ?  '' : 'info'" closable @close="handleClose(scope.data, child.wgtName)" @click="handleClick(scope.data, child, index)">-->
<!--                    {{child.wgtName}}-->
<!--                  </el-tag>-->
<!--                </div>-->
              </el-col>
            </draggable>
          </el-row>
          <el-button style="width: 150px" size="mini" @click="handleClickCom(scope.data)">{{!scope.data.children.length?'选择挂件':`已选${scope.data.children.length || 0} 个挂件`}}</el-button>
        </div>
      </template>
    </CompTodoList>
<!--   显示配置 -->
    <el-drawer
      :title="title"
      :append-to-body="false"
      :before-close="handleCloseDrawer"
      :visible.sync="innerDrawer">
      <div class="hm-setting" v-if="attrsArr.length">
        <attrPanel
          v-model="attrsArr[activeCompIndex]"
          :class="`wgt-attr-${attrsArr[activeCompIndex].name}`"
          :info="getComponentAttr(attrsArr[activeCompIndex])"
        />
<!--        <attrPanel-->
<!--          v-for="(itemData, index) of testArr"-->
<!--          :key="index"-->
<!--          v-model="testArr[index]"-->
<!--          :class="`wgt-attr-${itemData.name}`"-->
<!--          :info="getComponentAttr(itemData)"-->
<!--        />-->
      </div>
    </el-drawer>
    <el-dialog
      title="添加挂件"
      :visible.sync="dialogVisible" @close="handleCancel">
      <div class="com-box">

        <el-checkbox-group v-model="checkList">

          <el-checkbox :label="item.name" v-for="(item,index) of gWgtsArr" :key="index">
            <div
              :key="`wgt-item__${index}`"
              class="wgt-item"
              :data-name="item.name"
            >
              <!-- <i
                class="wgt-icon iconfont"
                :class="wgt.wgtIcon"
                        /> -->
              <div :class="['wgt-icon', item.wgtIcon]" />
              <div class="wgt-name">
                {{ item.wgtName}}
              </div>
            </div>
          </el-checkbox>
        </el-checkbox-group>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleConfirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Vue from 'vue'
import { cloneDeep } from 'lodash'
import CompTodoList from '../../comps/comp-todoList'
import { generateUniqueStrings } from './config'
import draggable from 'vuedraggable'
import gWgts from '../index'
import attrPanel from '../../attr_panel.vue'
export default {
  name: 'TopicItem',
  components: {
    draggable,
    CompTodoList,
    attrPanel
  },
  props: ['value'],
  data() {
    return {
      dragOptions: {
        animation: 300,
        forceFallback: false,
        scroll: true
      },
      localScene: '1001',
      dialogVisible: false,
      innerDrawer: false,
      checkList: [],
      // 热区
      gWgtsArr: [],
      attrsArr:[],
      activeCompIndex: null,
      title: '',
      childNum: null,
      nameVal: '',
      hideVal: 'HmNavigationTabs'
    }
  },
  created() {
    const wgts = gWgts[this.localScene]
    Object.keys(wgts).forEach((index) => {
      if(this.hideVal != wgts[index].name){
        this.gWgtsArr.push(wgts[index])
      }
    })
    // this.localValue = cloneDeep(this.value)
  },
  methods: {
    handleClickAdd() {
      this.value.push({
        id: generateUniqueStrings(1, 5)[0],
        title: 'Tab',
        children: []
      })
    },
    onChangeLink(e, index) {
      const v = cloneDeep(this.value[index])
      Vue.set(this.value, index, {
        ...v,
        ...e
      })
    },
    // 添加挂件
    handleClickCom(data) {
      const { id } = data
      this.nameVal = id
      this.dialogVisible = true
    },
    // 取消挂件
    handleCancel() {
      this.nameVal = ''
      this.dialogVisible = false
      this.checkList = []
    },
    // 添加挂件
    handleConfirm() {
      const arr = []
      this.checkList.forEach((li) => {
        // 是否存在挂件
        const wgt = this.gWgtsArr.find((item) => item.name.toLowerCase() == li.toLowerCase())
        if (wgt) {
          // console.log('getTemplateDetial wgt:', wgt)
          const wgtInitParams = this.cloneDefaultField(wgt)
          // 默认值
          // const params = wgt.config.transformIn(li.params)
          arr.push({
            wgtName: wgt.wgtName,
            ...wgtInitParams
          })
        }
      })
      // this.attrsArr = arr
     this.value.map((item, index) => {
        if(item.id === this.nameVal){
          Vue.set(this.value[index], 'children', item.children.concat([...arr]))
        }
      })
      this.dialogVisible = false
    },
    // 去除挂件
    handleClose(data, name, num) {
      console.log(data, name, num)
      this.value.map((item, index) => {
        if(item.id === data.id){
          item.children.splice(num, 1)
          Vue.set(this.value[index], 'children', [...item.children])
        }
      })
    },
    cloneDefaultField(e) {
      const { wgtName, wgtDesc, config } = e
      const { setting, name } = JSON.parse(JSON.stringify(config))
      const compData = {
        name,
        wgtName,
        wgtDesc
      }
      setting.forEach((item) => {
        compData[item.key] = item.value
      })
      // console.log('compData', compData)
      return compData
    },
    getComponentAttr(item) {
      const { wgtName, config } = this.gWgtsArr.find((wgt) => {
        return wgt.name.toLowerCase() == item.name.toLowerCase()
      })
      return {
        wgtName,
        ...config
      }
    },
    // 点击挂件
    handleClick(data, child, index) {
      this.title = `${data.title} / ${child.wgtName}`
      this.attrsArr = data.children || []
      this.activeCompIndex = index
      this.childNum = `${index}${data.title}`
      this.innerDrawer = true
    },
    // 挂件属性编辑
    handleCloseDrawer() {
      this.innerDrawer = false
      this.attrsArr = []
      this.title = ''
    }
  }
}
</script>
<style lang="scss">
.attr-topic-item {
  .topic-input {
    width: 150px;
    margin-bottom: 6px;
  }
  .comp-picker-link {
    width: 220px;
  }
  .btn-linkpath {
    max-width: 100%;
  }
  .tag-item{
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid #d9d9d9;
    border-radius: 10px;
    margin-bottom: 6px;
    cursor: pointer;
    &.active{
      border-color: #155bd4;
    }
    .tag-icon{
      position: absolute;
      right: -6px;
      top: -6px;
      font-size: 14px;
      cursor: pointer;
    }
  }
  .wgt-item {
    width: 80px;
    height: 100px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    &:hover {
      background: #537ffd;
      .wgt-icon {
        color: #fff;
        background-position-y: -48px;
      }
      .wgt-name {
        color: #fff;
      }
    }
  }
  .wgt-icon {
    font-size: 26px;
    color: #666;
    width: 48px;
    height: 48px;
    background-repeat: no-repeat;
    background-size: 100%;
    &.wgt-slider {
      background-image: url('../../../../assets/imgs/decorate/wgt-slider.png');
    }
    &.wgt-hotzone {
      background-image: url('../../../../assets/imgs/decorate/wgt-hotzone.png');
    }
    &.wgt-goodsgrid {
      background-image: url('../../../../assets/imgs/decorate/wgt-goodsgrid.png');
    }
    &.wgt-film {
      background-image: url('../../../../assets/imgs/decorate/wgt-film.png');
    }
    &.wgt-coupon {
      background-image: url('../../../../assets/imgs/decorate/wgt-coupon.png');
    }
    &.wgt-showcase {
      background-image: url('../../../../assets/imgs/decorate/wgt-showcase.png');
    }
    &.wgt-goods-grid-tab {
      background-image: url('../../../../assets/imgs/decorate/wgt-goods-grid-tab.png');
    }
    &.wgt-store {
      background-image: url('../../../../assets/imgs/decorate/wgt-store.png');
    }
    &.wgt-goods-scroll {
      background-image: url('../../../../assets/imgs/decorate/wgt-goods-scroll.png');
    }
    &.wgt-marquees {
      background-image: url('../../../../assets/imgs/decorate/wgt-marquees.png');
    }
    &.wgt-hotTopic {
      background-image: url('../../../../assets/imgs/decorate/wgt-hotTopic.png');
    }
    &.wgt-search {
      background-image: url('../../../../assets/imgs/decorate/wgt-search.png');
    }
    &.wgt-floorImg {
      background-image: url('../../../../assets/imgs/decorate/wgt-floorImg.png');
    }
    &.wgt-nearby-shop {
      background-image: url('../../../../assets/imgs/decorate/wgt-nearby-shop.png');
    }
    &.wgt-img-navigation {
      background-image: url('../../../../assets/imgs/decorate/wgt-img-navigation.png');
    }
    &.wgt-headline {
      background-image: url('../../../../assets/imgs/decorate/wgt-headline.png');
    }
  }
  .wgt-name {
    height: auto !important;
    line-height: 20px !important;
    color: #666;
    font-size: 13px !important;
    border: none !important;
  }
}
.hm-setting{
  padding: 20px;
}
</style>
